import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Title,
  Card,
  Copy,
  Bold,
  Input,
  Row
} from "app/NativeComponents/common";
import Quote from "app/DealMachineCore/snippets/Quote";
import SkipButton from "./SkipButton";

import { loadDashboardStep } from "app/NativeActions";
import EnterpriseGoals from "../Goals/EnterpriseGoals";

class SetGoalsEnterpriseStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      dashboard_step: null
    };

    this.completedStep = this.completedStep.bind(this);
  }

  componentDidMount() {
    loadDashboardStep("set_goals_enterprise")
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              dashboard_step: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  getOptionTitle({ value, array }) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].value == value) {
        return array[i].label;
      }
    }
  }

  renderContents(dashboard_step) {
    //if (!this.state.completed_step) {
    return (
      <Wrapper>
        <EnterpriseGoals />
        <Wrapper>
          <Copy>
            <Bold
              style={{
                display: this.props.device == "desktop" ? "inline" : "none"
              }}
            >
              {dashboard_step.header}
            </Bold>
            <Copy
              style={{
                display: this.props.device == "desktop" ? "inline" : "none"
              }}
            >
              {dashboard_step.description}
            </Copy>
            <Copy
              style={{
                display: this.props.device == "desktop" ? "inline" : "none"
              }}
            >
              {dashboard_step.otherText}
            </Copy>
          </Copy>
        </Wrapper>
        <SkipButton
          //completed_step={this.state.completed_step}
          onPress={this.completedStep}
          title={dashboard_step.nextButtonText}
        />
      </Wrapper>
    );
    //}
  }

  completedStep() {
    this.props.updateTab("build_your_team");
    this.props.updateDashboard({
      token: this.props.token,
      type: "enterprise_step",
      current_step: "build_your_team"
    });
  }

  render() {
    const { loading, dashboard_step } = this.state;
    if (this.props.active_tab == "set_goals_enterprise") {
      if (!loading && dashboard_step) {
        return (
          <Wrapper>
            <CardBody>{this.renderContents(dashboard_step)}</CardBody>
          </Wrapper>
        );
      }
    }
    return <Wrapper />;
  }
}

export default SetGoalsEnterpriseStep;
